import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { routes } from '../../MainPage'
import { useNavigate } from 'react-router-dom'
// import {DiesaseArr} from '../../Screens/Disease/DiseaseAll'
// import svg from '../img/symbol.svg'
function Sevices(props) {

    var navigate = useNavigate()
    var DiesaseArr = [
        { name: routes.allergic, lable: 'Allergic Rhinitis', },
        { name: routes.AnalFissure, lable: 'Anal fissure' },
        { name: routes.anemia, lable: 'Anemia', },
        { name: routes.anorexiaNervosa, lable: 'Anorexia nervosa', },
        { name: routes.dyspnea, lable: 'Dyspnea', },
        { name: routes.hepatitis, lable: 'Hepatitis', },
        { name: routes.cancer, lable: 'Cancer', },
        { name: routes.autism, lable: 'Autism', },
        { name: routes.chickenpox, lable: 'Chickenpox', },
        { name: routes.deafness, lable: 'Deafness', },
    ]
    DiesaseArr.sort((a, b) => (a.lable > b.lable) ? 1 : ((b.lable > a.lable) ? -1 : 0))
    const slides = [];
    DiesaseArr.forEach((item, idx) => {
        var DisaseSvgid = '#disease_' + (idx + 1)

        slides.push(
            <SwiperSlide key={idx} className="services_item">
                <div className="services_inner" onClick={() => navigate(item.name)}>
                    <span className="disease_icon">
                        <svg viewBox="0 0 64 64">
                            <use xlinkHref={DisaseSvgid} />
                        </svg>
                    </span>
                    <h5>{item.lable}</h5>
                    <a href={item.name} className="arrow" >
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068    c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557    l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104    c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z" />
                            </svg>
                        </span>
                    </a>
                </div>
            </SwiperSlide>
        );
    });
    return (
        <div className="web-sect pad-60">
            <div className="services-bg">
                <div className="row services-wrapper">
                    <div className="col-xs-12 col-5 services-txt">
                        <div className="title-box">
                            <span className="subtitle">Services</span>
                            <h3 className="text-center">
                                We Cover A Big Variety Of Homeopathic Medical Treatment Services
                            </h3>
                            <button className="btn text-center" onClick={() => { navigate(routes.disease) }}>View All</button>
                        </div>
                    </div>
                    <div className="col-xs-12 col-7 services-right">
                        <div>
                            <Swiper className="services_wrap" spaceBetween={0}
                                slidesPerView={3.5}
                                effect={"slide"}
                                freeMode={true}
                                pagination={{
                                    el: ".swiper-pagination",
                                    clickable: true,
                                }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1.5,
                                    },
                                    576: {
                                        slidesPerView: 2.5,
                                    },
                                    768: {
                                        slidesPerView: 1.5,
                                    },
                                    992: {
                                        slidesPerView: 2.5,
                                    },
                                    1441: {
                                        slidesPerView: 3.5,
                                    }

                                }}>
                                {slides}
                            </Swiper>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sevices;